var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocsicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MirrorFly_Docs",
    "data-name": "MirrorFly Docs",
    transform: "translate(-1716 -287)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32909",
    "data-name": "Group 32909",
    transform: "translate(1716 287)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_32",
    "data-name": "Ellipse 32",
    fill: "#e0effa",
    stroke: "#3b9dda",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 39.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24",
    transform: "translate(24 24)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    width: 32,
    height: 32,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23",
    transform: "translate(4.483 2.443)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M675.47,223.762h-9.655a5.544,5.544,0,0,0-5.564,5.412V244.72a5.556,5.556,0,0,0,5.43,5.676c.045,0,.089,0,.133,0h11.594a5.64,5.64,0,0,0,5.412-5.676v-13.3Z",
    transform: "translate(-660.25 -223.745)",
    fill: "none",
    stroke: "#171717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M670.475,223.75v4.222a3.736,3.736,0,0,0,3.727,3.737h4",
    transform: "translate(-655.637 -223.75)",
    fill: "none",
    stroke: "#171717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M672.725,236.359h-7.837",
    transform: "translate(-658.157 -218.061)",
    fill: "none",
    stroke: "#171717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M669.757,232.606h-4.87",
    transform: "translate(-658.158 -219.754)",
    fill: "none",
    stroke: "#171717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocsicon);
export default __webpack_public_path__ + "static/media/docsicon.b0f543af.svg";
export { ForwardRef as ReactComponent };